import React, { useState, useEffect, useRef } from 'react';
import Api from '../../../__helpers/api';

import Methods from '../../settings/methods/Methods';
import { useHistory, Link } from 'react-router-dom';

//images
import closeWhiteIcon from '../../../assets/images/profile/close-icon-white.png';
import back from '../../../assets/images/profile/left-arrow-blue.png'
import successPayment from '../../../assets/images/profile/success-payment.png'
import failPayment from '../../../assets/images/profile/fail-payment.png'
import videoIcon from '../../../assets/images/profile/activation-video.png'
import testsIcon from '../../../assets/images/profile/activation-tests.png'
import commentIcon from '../../../assets/images/profile/activation-comment.png'
import communicationIcon from '../../../assets/images/profile/activation-communication.png'
import responsiveIcon from '../../../assets/images/profile/activation-responsive.png'
import periodIcon from '../../../assets/images/profile/activation-period.png'
import boxSignImage from '../../../assets/images/profile/box-sign.png'
import bgImage from '../../../assets/images/profile/methods/bg.jpg'
import downArrowIcon from '../../../assets/images/profile/methods/down-arrow.png'

//modals
import CodeModal from './Code'

function Activate(props) {

    const history = useHistory();

    const [activation, setActivation] = useState({
        firstPart: '',
        secondPart: '',
        //modals
        showOverlay: false,
        successOverlay: false,
        successModal: false,
        mainSuccessMessage: 'Всички теми са успешно активирани!',
        secondarySuccessMessage: 'След успешното активиране на темите, може да продължиш с обучението си.',
        errorOverlay: false,
        errorModal: false,
        mainErrorMessage: 'Невалиден код!',
        secondaryErrorMessage: 'Моля, провери въведения код.',
        //end modals
        loading: false,
        //temporary
        payment: false,
        successPayment: false,
        toggleIncluded: false,
    });

    const codeModalRef = useRef(null)

    useEffect(() => {
        if (props.blur) {
            document.querySelector('body').style.overflow = 'hidden'
        }
    }, [props.blur])

    useEffect(() => {
        let paymentHash = new URLSearchParams(window.location.search).get('hash');
        let hasSuccess = new URLSearchParams(window.location.search).get('success');
        let hasCancel = new URLSearchParams(window.location.search).get('fail');

        if (hasSuccess) {
            setActivation(activation => {
                return {
                    ...activation,
                    payment: true,
                    successPayment: true,
                }
            })
        }

        if (hasCancel) {
            setActivation(activation => {
                return {
                    ...activation,
                    payment: true,
                    successPayment: false,
                }
            })
        }

        if (hasSuccess && paymentHash) {
            Api.post('payment/epay/complete', {
                hash: paymentHash
            });
        }

        // history.replace('/');

    }, [])


    const handleClose = () => {
        props.close(false)
        document.querySelector('body').style.overflow = 'initial'

        setActivation(activation => {
            return {
                ...activation,
                successModal: false
            }
        })
        setTimeout(() => {
            // props.activationMethood(false);
            setActivation(activation => {
                return {
                    ...activation,
                    successOverlay: false
                }
            })
        }, 100);
    }
    const handleToggleMettod = () => {
        props.activationMethood(false, true);
    }
    const handleClosePaymentMessage = () => {
        setActivation(activation => {
            return {
                ...activation,
                payment: false
            }
        });
    }

    const handleCode = () => {
        codeModalRef.current.open()
        handleClose()
        document.querySelector('body').style.overflow = 'hidden'
    }

    const handleBack = () => {
        codeModalRef.current.close()
        props.open()
        document.querySelector('body').style.overflow = 'hidden'
    }

    const hideCodeModal = () => {
        props.hideCodeModal && props.hideCodeModal()
    }

    useEffect(() => {
        if (props.popup) {
            Api.post('student/increase-activation-count')
        }
    }, [props.popup])

    const handleToggleIncluded = () => {
        setActivation(prev => ({
            ...prev,
            toggleIncluded: !prev.toggleIncluded
        }))
    }

    return (
        <>
            {activation.payment ?
                <div id="overlay" className="visible">
                    {activation.successPayment ?
                        <div className="methods-popup payment-message show">
                            <img src={successPayment} alt="success" />
                            <h2>
                                Плащането Ви е прието и чака обработка!
                            </h2>
                            <p>
                                След обработване на Вашето плащане ще може да продължите с обучението си.
                            </p>
                            <h4 onClick={handleClosePaymentMessage}>
                                <img src={back} alt="back" />
                                Към обучението
                            </h4>
                        </div>
                        :
                        <div className="methods-popup payment-message show">
                            <img src={failPayment} alt="fail" />
                            <h2>
                                Отказано плащане!
                            </h2>
                            <p>
                                Авто Обучение предоставяме свободен достъп до всичко наши видео уроци и
                                учебни материали в системата.
                            </p>
                            <h4 onClick={handleClosePaymentMessage}>
                                <img src={back} alt="back" />
                                Към обученито
                            </h4>
                        </div>
                    }
                </div>
                :
                <div id="overlay" className={`methods-overlay ${props.blur ? 'visible' : ''}`}>
                    <div className={`methods-popup ${props.popup ? 'show' : ''}`}>
                        <div className="top-part">
                            <img src={bgImage} />
                            <div className="right-part">
                                <img src={boxSignImage} alt="Авто Обучение" />
                                <button
                                    className={`view-more ${activation.toggleIncluded ? 'rotate' : ''}`}
                                    onClick={handleToggleIncluded}
                                >
                                    Виж подробности
                                    <img src={downArrowIcon} />
                                </button>
                                <ul className="included" style={!activation.toggleIncluded && window.innerWidth <= 1024 ? { display: 'none' } : {}}>
                                    <li>
                                        <img src={videoIcon} alt="video" />
                                            Видео обучение по учебната програма
                                        </li>
                                    <li>
                                        <img src={testsIcon} alt="test" />
                                            Изпитни въпроси за всяка тема
                                        </li>
                                    <li>
                                        <img src={commentIcon} alt="comment" />
                                            Коментар от закона за всеки въпрос
                                        </li>
                                    <li>
                                        <img src={communicationIcon} alt="communication" />
                                            Задаване на въпроси към преподаваел
                                        </li>
                                    <li>
                                        <img src={responsiveIcon} alt="responsive" />
                                            За всички мобилни устройства
                                        </li>
                                    <li>
                                        <img src={periodIcon} alt="Period" />
                                        Валидност 3 месеца от активация
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <img src={closeWhiteIcon} alt="close" onClick={handleClose} className="close-activation close-small" />
                        <h2 className="on-desktop">
                            Активирай или намери Авто Обучение
                        </h2>
                        <h2 className="on-mobile">
                            Активирай Авто Обучение
                        </h2>
                        <Methods
                            callbackUrl=""
                            handleActivete={handleCode}
                            handleClose={handleClose}
                        />
                    </div>
                </div>
            }
            <CodeModal
                ref={codeModalRef}
                handleBack={handleBack}
                hideCodeModal={hideCodeModal}
            />
        </>
    )
}

export default Activate;